import i18next from 'i18next';
import i18nextXHRBackend from 'i18next-xhr-backend';

export interface i18nProps {
  siteLanguage: string;
  fallbackLanguage: string;
  baseUrl?: string;
}

const i18n = ({ siteLanguage, fallbackLanguage, baseUrl = '' }: i18nProps) => {
  return i18next.use(i18nextXHRBackend).init({
    lng: siteLanguage,
    fallbackLng: [fallbackLanguage, 'en'],
    keySeparator: '$',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${baseUrl}assets/locale/messages_{{lng}}.json`,
      crossDomain: true,
    },
  });
};

export default i18n;
